export default "__VITE_ASSET__C452nWml__"